import { render, staticRenderFns } from "./inventoryBalanceDetailsModal.vue?vue&type=template&id=3dbbaa55"
import script from "./inventoryBalanceDetailsModal.vue?vue&type=script&lang=js"
export * from "./inventoryBalanceDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports